import { IComponent } from '../interfaces/IComponent'
import { IComponentGameObject } from '../interfaces/IComponentGameObject'
import { IComponentsService } from '../interfaces/IComponentsService'
import { Constructor } from '../types/types'
import short from 'short-uuid'


export default class ComponentService
	implements IComponentsService
{
	private componentsByGameObject = new Map<string, IComponent[]>();
	private queuedForStart: IComponent[] = [];


	public AddComponent(go: IComponentGameObject, component: IComponent): void
	{
		if (!go.cid)
		{
			go.cid = short.generate();
			go.components = this;
			// register internal hash
			this.componentsByGameObject.set(go.cid, [])
		}
		
		const list = this.componentsByGameObject.get(go.cid);
		list!.push(component);
		
		// initialize the component
		component.Init(go, this);

		if (component.Awake)
		{
			component.Awake();
		}

		if (component.Start)
		{
			this.queuedForStart.push(component);
		}
	}

	public RemoveComponent(go: IComponentGameObject, component: IComponent): void
	{
		if (!go.cid) {
			return
		}

		if (!this.componentsByGameObject.has(go.cid)) {
			return
		}

		const list = this.componentsByGameObject.get(go.cid) as IComponent[]
		const index = list.findIndex(comp => comp === component)

		if (index < 0) {
			return
		}

		list.splice(index, 1)

		component.Destroy?.()
	}

	public RemoveAllComponents(go: IComponentGameObject): void
	{
		const components = this.componentsByGameObject.get(go.cid) ?? []
		components.forEach(component => {
			component.Destroy?.()
		})

		this.componentsByGameObject.delete(go.cid)
	}

	public GetAllComponents(go: IComponentGameObject): IComponent[]
	{
		const result: IComponent[] = this.componentsByGameObject.get(go.cid) ?? []

		return result;
	}

	public GetComponent<ComponentType>(go: IComponentGameObject, componentType: Constructor<ComponentType>): ComponentType
	{
		const components = this.componentsByGameObject.get(go.cid) ?? []
		return components.find(component => component instanceof componentType) as unknown as ComponentType | undefined
	}

	public Update(dt: number): void
	{
		while (this.queuedForStart.length > 0) {
			const component = this.queuedForStart.shift()
			if (component && component.Start) {
				component.Start()
			}
		}

		this.componentsByGameObject.forEach(components => {
			// create shallow copy for added remove
			components.slice().forEach(component => {
				if (component.Update) {
					component.Update(dt);
				}
			})
		})
	}

	public Destroy(): void
	{
		this.componentsByGameObject.forEach(components => {
			components.forEach(component => {
				if (component.Destroy) {
					component.Destroy();
				}
			})
		})
		this.componentsByGameObject = null;
		this.queuedForStart = null;
	}
}